import { Link } from 'react-router-dom';
import { motion } from 'motion/react';
import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
import { useFileStore } from '../../stores/fileStore';

export function FileBreadcrumb() {
  const breadcrumb = useFileStore((s) => s.breadcrumb);

  if (breadcrumb.length === 0) return null;

  return (
    <motion.nav
      initial={{ opacity: 0, x: -10 }}
      animate={{ opacity: 1, x: 0 }}
      className="flex items-center gap-1 text-sm mt-2"
    >
      <Link
        to="/"
        className="flex items-center gap-1 text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-200 transition-colors"
      >
        <HomeIcon className="w-4 h-4" />
        <span>Home</span>
      </Link>

      {breadcrumb.map((item, index) => (
        <motion.div
          key={item.id}
          initial={{ opacity: 0, x: -10 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: index * 0.05 }}
          className="flex items-center gap-1"
        >
          <ChevronRightIcon className="w-4 h-4 text-gray-400 dark:text-slate-500" />
          {index === breadcrumb.length - 1 ? (
            <span className="text-gray-900 dark:text-white font-medium">{item.name}</span>
          ) : (
            <Link
              to={`/folder/${item.id}`}
              className="text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-200 transition-colors"
            >
              {item.name}
            </Link>
          )}
        </motion.div>
      ))}
    </motion.nav>
  );
}
